import { ReactElement, cloneElement } from 'react';

import {
  RenderRowsInfo,
  ShowRowsConfig,
  COACH_LIST_COLUMN,
} from '../NgzCoachList.settings';

export const getShowColumns = (
  renderRowsInfo: RenderRowsInfo,
  showRowsConfig: ShowRowsConfig,
): ReactElement<any>[] => {
  const showColumnsKeys = Object.values(COACH_LIST_COLUMN).filter(
    (columnKey) => showRowsConfig[columnKey],
  );

  return showColumnsKeys.map((columnKey) => {
    const element = renderRowsInfo[columnKey];

    return cloneElement(element, {
      key: columnKey,
    });
  });
};
